import { MaterialEstimate } from "./material-estimate.model";

export class Building {
    buildingName: any;
    materialEstimates: MaterialEstimate[];

    constructor() {
        this.materialEstimates = [
            {
                cost: '',
                unitOfPropertyDetails: '',
                unitOfPropertyDescription: '',
                quantity: 0,
                unitCosts: '',
                totalCosts: 0
              }
        ];
        this.buildingName = '';
    }
}